module.exports = __webpack_public_path__ + "static/media/scroll.e2b16321.svg";